import { AddPlusButton } from '@components/core-ui/buttons/AddPlusButton';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import { WorkspaceWithStatusesResponseDto } from 'app/API';
import { TWorkspace } from 'app/types/entities/TWorkspace';
import React from 'react';
import { useNavigate } from 'react-router';
import { WorkspaceCard } from './components/WorkspaceCard';
import { Wrapper } from './styles/Wrapper';

export type TProps = {
  workspaces: WorkspaceWithStatusesResponseDto[];
};

export function WorkspacesCards({ workspaces }: TProps) {
  const navigate = useNavigate();
  const { me } = useAuthContext();
  const { openModal } = useModalContext();

  const handleWorkspaceClick = (event: React.MouseEvent, workspace: TWorkspace) => {
    const organization = me.organizations.find((o) => o.id === workspace.organizationId);
    event.preventDefault();
    if (organization) {
      navigate(routes.jobsList.make(organization?.slug ?? '', workspace.slug));
    }
  };

  const handleCreateWorkspace = () => {
    openModal(ModalNamesEnum.NewWorkspaceModal);
  };

  return (
    <Wrapper>
      <ul className="list">
        {workspaces.map((workspace) => {
          const organization = me.organizations.find((o) => o.id === workspace.organizationId);
          return (
            <WorkspaceCard
              key={workspace.id}
              workspace={workspace}
              organization={organization}
              handleWorkspaceClick={handleWorkspaceClick}
            />
          );
        })}
        <AddPlusButton onClick={handleCreateWorkspace} variant="workspace" ariaLabel="Create workspace" />
      </ul>
    </Wrapper>
  );
}
